import { render, staticRenderFns } from "./PermissionRoleDetail.vue?vue&type=template&id=e377b60c&scoped=true"
import script from "./PermissionRoleDetail.vue?vue&type=script&lang=js"
export * from "./PermissionRoleDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e377b60c",
  null
  
)

export default component.exports